import 'antd/lib/table/style'
import { Table } from './table'
import './table.less'

export * from './table'

export default Table
